/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { Owner } from "@/models/api/Owner";
import {
  getCashiers,
  getCashiersWithCode,
  GetOfficeCashierAndTradersResponse,
  getOfficeProfileCashierAndTraders,
} from "@/requests/general";

export interface CashiersAndTradersStateInterface {
  officeProfileCashiers: null | Array<Owner>;
  officeProfileTraders: null | Array<Owner>;
  cashiers: null | Array<Owner>;
  cashiersWithCode: null | Array<Owner>;
}

export const CashiersAndTradersState: CashiersAndTradersStateInterface = {
  officeProfileCashiers: null,
  officeProfileTraders: null,
  cashiers: null,
  cashiersWithCode: null,
};

const CashiersAndTradersModule = defineModule({
  state: CashiersAndTradersState as CashiersAndTradersStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setOfficeProfileCashiersAndTraders(state, param: GetOfficeCashierAndTradersResponse) {
      state.officeProfileTraders = param.traders;
      state.officeProfileCashiers = param.cashiers;
    },
    setCashiers(state, param: Array<Owner>) {
      state.cashiers = param;
    },
    setCashiersWithCode(state, param: Array<Owner>) {
      state.cashiersWithCode = param;
    },
  },
  actions: {
    async downloadOfficeProfileCashiersAndTraders(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.officeProfileCashiers === null && state.officeProfileTraders === null) {
        const response = await getOfficeProfileCashierAndTraders();
        commit.setOfficeProfileCashiersAndTraders(response);
      }
    },
    async downloadCashiers(context) {
      const { commit } = _moduleActionContext(context);
      const response = await getCashiers();
      commit.setCashiers(response);
    },
    async downloadCashiersWithCode(context, userId: string | null = null) {
      const { commit } = _moduleActionContext(context);
      const response = await getCashiersWithCode(userId);
      commit.setCashiersWithCode(response);
    },
  },
});

export default CashiersAndTradersModule;

/* eslint-disable */
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, CashiersAndTradersModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, CashiersAndTradersModule);
